export default "__VITE_ASSET__DbmwMkst__"